/* global $, openUrl */
import SGLink from '../shopgate-link';
import SGActionCommand from '../../app/sg-actions/sg-action-command';

function SubscriptionProduct() {
  let endpoints = {};
  let options = {};
  let subscriptionId;

  /**
   * Set the endpoints property
   * @param {Object} _endpoints - List of endpoint
   */
  const setEndpoints = function (_endpoints = {}) {
    endpoints = _endpoints;
  };

  /**
   * Set the options property
   * @param {Object} _options - List of options
   */
  const setOptions = function (_options = {}) {
    options = _options;
  };

  /**
   * Set the current subscription id
   * @param {number} _subscriptionId - id of the subscription setting
   */
  const setSubscriptionId = function (_subscriptionId) {
    subscriptionId = _subscriptionId;
  };

  /**
   * Parses product data and checks if the tags contain any of the defined subscription ids
   * @param product - product data
   * @returns {*} subscription id
   */
  const getSubscriptionIdFromData = function (product) {
    let tags = [];
    if (product.tags) {
      tags = product.tags.trim().split(',');
    }

    for (const i in tags) {
      if (tags.hasOwnProperty(i) && tags[i].indexOf(options.productTagPrefix) === 0) {
        return tags[i].replace(options.productTagPrefix, '');
      }
    }

    return null;
  };

  /**
   * Checks if from a list of tags, one tag is the one we allow
   * @param {Object} product - product data
   * @returns {boolean} Tag found in list or not
   */
  const isSubscriptionProduct = function (product) {
    return getSubscriptionIdFromData(product) !== null;
  };

  /**
   * Create the dropdown
   * @returns {null|jQuery} A select element or null
   */
  const buildSelect = function () {
    const $dropdown = $('<select>').attr({
      class: 'form-control selectpicker show-tick',
    }).css({
      display: 'none',
    });

    if (!subscriptionId || !options.subscriptions[subscriptionId].intervalFrequency) {
      return $dropdown;
    }

    $.each(options.subscriptions[subscriptionId].intervalFrequency, (key, subscriptionValue) => {
      const $subscriptionOption = $('<option>')
        .addClass('no-sg-action')
        .html(subscriptionValue)
        .val(key)
        .attr('data-subtext', `${$.i18n._('subscription_frequency')} : `);

      // append the options to the select
      $dropdown.append($subscriptionOption);
    });

    return $dropdown;
  };

  /**
   * Handle the add to cart event
   * @param {Object} productNumber - Productnumber
   * @param {number} quantity - Number of products
   * @param {number} shippingIntervalFrequency - the selected frequency
   */
  const addItemToCart = function (productNumber, quantity, shippingIntervalFrequency) {
    const command = {
      ver: window.SGAction.version,
      cmds: [new SGActionCommand('broadcastEvent', { event: 'showPreviousTab', parameters: [] })],
    };

    const rechargeReturnUrl = typeof window.pageInformation !== 'undefined'
      ? `sgcmd:${JSON.stringify(command)}`
      : window.location.href;

    const data = {
      addToCartUrl: endpoints.addToCartUrl,
      checkoutUrl: endpoints.checkoutUrl,
      rechargeReturnUrl,
      quantity,
      id: productNumber,
      subscriptionId,
      shippingIntervalFrequency,
      shippingIntervalUnitType: options.subscriptions[subscriptionId].intervalFrequencyType,
    };

    const url = new SGLink(endpoints.trampolineUrl);
    url.setParams(data);
    openUrl({
      src: url.toString(),
    });
  };

  return {
    setEndpoints,
    setOptions,
    setSubscriptionId,
    isSubscriptionProduct,
    buildSelect,
    addItemToCart,
    getSubscriptionIdFromData,
  };
}

export default SubscriptionProduct;



// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/shopgate-subscription-product.js